import { inject } from '@angular/core';
import { FunctionalEffect, createEffect } from '@ngrx/effects';
import { ofType, Actions } from '@ngrx/effects';
import { map, of, switchMap } from 'rxjs';
import {
  loadBuildInfo,
  loadBuildInfoError,
  loadBuildInfoSuccess,
} from '@app/core/store/app-context/app-context.actions';
import { catchError } from 'rxjs/operators';
import { BuildInfoApiService } from '@app/api/services/build-info-api.service';

export const loadBuildInfo$: FunctionalEffect = createEffect(
  (actions$ = inject(Actions), buildInfoApiService = inject(BuildInfoApiService)) =>
    actions$.pipe(
      ofType(loadBuildInfo),
      switchMap(() =>
        buildInfoApiService.get().pipe(
          map(response => loadBuildInfoSuccess({ data: response })),
          catchError(() => of(loadBuildInfoError()))
        )
      )
    ),
  { functional: true }
);
